module.exports = __webpack_public_path__ + "img/collection-engagementRingsRosegold@2x.4a02cc6.jpg";